import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Reset scroll position on every route change (fixes Z-07). */
export function useScrollToTopOnNavigate(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
}
